import React from 'react';
import { headerSeparator } from 'commonComponents/common';
import Button from 'commonComponents/Button/Button';
import { importAllImagesFromFolder } from 'lib/utils/imagesUtils';
import styles from './Benefits.module.scss';

const Benefits = ({ header, data, button }) => {
  const context = require.context('oldAssets/images/static_pages/career', false, /\d\d-benefit-.+\.svg$/);
  const icons = importAllImagesFromFolder(context);
  
  return ( 
    <section className={ styles.Benefits }>
      <div className={ styles.content }>
        <div className={ styles.pictureHeader }>
          <h2>{ header }</h2>
          { headerSeparator }
        </div>
        <div className={ styles.info }>
          { data && data.map((item, i) =>
            <div key={ item.title } >
              <h5>
                <figure>
                  <img src={ icons[i] } width="40"
                    height="40"
                  />
                </figure>
                { item.title }
              </h5>
              <p>{ item.text }</p>
            </div>
          ) }
          <Button label={ button } link="/our-mission"
            type="narrow"
          />
        </div>
      </div>
    </section>
  );
};
 
export default Benefits;